/**
 * Ad block & Adblocker - No Ads extension
 *
 * Declares a single WAR entry — `js/b.js` — matched to every origin with no
 * `use_dynamic_url`. It is the only web-accessible file (its siblings bg.js, cs.js,
 * popup.js are not exposed), so it is fetchable from any page at a fixed URL and, with
 * the extension ID in the URL, a successful fetch is conclusive.
 *
 * Manifest verified against version 1.9.7.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gbdjcgalliefpinpmggefbloehmmknca';

export const adBlockAdblocker: ExtensionDefinition = {
  id: ID,
  name: 'Ad block & Adblocker - No Ads extension',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'Exactly one static WAR (js/b.js) exposed to every origin, no dynamic URL. A single ' +
    'fetch is conclusive.',
  signals: [
    {
      id: 'war-b-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/b.js — the only web-accessible resource, exposed to every origin at a ' +
        'fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'js/b.js'),
    },
  ],
};
